import Gallery from "webPage/Gallery";
import Page from "webPage/Page";
import $ from "jquery";
import GraphAnimation from "GraphAnimation";
import { scrollToElement } from "util/general";

Page.register('/', function () {
    new GraphAnimation($(".js-demo-container"));

    sliderHandler($('.js-staff-slider'));
    sliderHandler($('.js-sectors-slider'));

    $("body").on("click", ".js-scroll-to-link", function () {
        console.log("test");
        let $target = $($(this).attr("href"));

        if ($target.length === 0) return true;

        scrollToElement($target, 1000);

        return false;
    })
});


function sliderHandler($el) {
    let slider = new Gallery($el, {
        itemClass: "info-slide__item",
        pipClass: "info-slide-btn",
        navigateClass: "js-navigate",
        pipsClass: "js-pips",
        itemsClass: "js-slide-wrap",
        itemActiveModifier: "active",
        pipActiveModifier: "active",
        animationDuration: 0,
        applyMinHeight: false,
    });

    let updatePipPosition = function (animate = true) {
        let $pip = slider.$pips.find("." + slider.settings.pipClass).eq(slider.getActiveIndex());
        let triangleWidth = $('.info-slide__triangle-wrap').outerWidth() / 2;

        let pipPos = $pip.position().left + ($pip.outerWidth() / 2) - triangleWidth;

        let $triangle = $el.find('.info-slide__triangle-wrap');

        if (!animate) {
            $triangle.addClass("info-slide__triangle-wrap--no-animate");
        }

        $triangle.css({
            "transform": "translateX(" + pipPos + "px)",
        });

        if (!animate) {
            // Force reflow
            $triangle.offset();
            $triangle.removeClass("info-slide__triangle-wrap--no-animate");
        }
    };

    slider.on('transitionEnd', function ({to}) {
        updatePipPosition();
    });

    updatePipPosition(false);
    $el.find('.info-slide__triangle-wrap').removeClass("info-slide__triangle-wrap--hidden");
    $(window).on('resize', function () {
        updatePipPosition(false);
    });
}
